import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectItem} from 'src/models/general/select.item.model';
import {DynamicConfigService} from 'src/modules/dynamic-config/services/config/dynamic-config.service';
import {Observable} from 'rxjs';

export interface DynamicFieldValueTagModel {
	uuid: string;
	value: string;
	compareSymbol?: string;
	include?: boolean | string;

	tag?: any;
}

@Component({
    selector: 'pim-dynamic-field-value-tag-list',
    templateUrl: './dynamic-field-value-tag-list.component.html',
    styleUrls: ['./dynamic-field-value-tag-list.component.sass'],
    standalone: false
})
export class DynamicFieldValueTagListComponent {
	@Input()
	values: DynamicFieldValueTagModel[] | undefined;

	@Input()
	disabled: boolean = false;

	@Input()
	tag!: string;

	@Output()
	removeValue: EventEmitter<DynamicFieldValueTagModel> = new EventEmitter<DynamicFieldValueTagModel>();

	fields$!: Observable<SelectItem[]>;

	constructor(private dynamicConfigService: DynamicConfigService) {
		this.fields$ = dynamicConfigService.getDynamicFieldsAsSelectItem();
	}

	removeEntry(model: DynamicFieldValueTagModel): void {
		if (this.disabled) {
			return;
		}
		model.tag = this.tag;

		this.removeValue.emit(model);
	}
}
